<template>
  <div class="box">
    <div class="videoWrapper">
      <iframe title="Bibliotecas Digitales"
              class="my-4"
              type="text/html"
              width="640"
              height="390"
              :src="`https://www.youtube.com/embed/${video}/?autoplay=1`"
              frameborder="0"
              allowfullscreen="">
      </iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'YoutubeVideo',
  props: {
    video: {
      type: String,
      default: 'R5A9ww2Uy7Y',
    },
  },
}
</script>

<style scoped>
  .box{
    max-width: 700px;
    margin: 0 auto
  }
  .videoWrapper {
    position: relative;
    padding-bottom: 56.25%; /* 16:9 */
    height: 0;
  }

  .videoWrapper iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
</style>
